import { StatusUserResponse } from "@/main/models/response";
import { useStyles } from "./styles";
import { StatusUserEnum } from "@/main/services/enum/StatusUserEnum";

interface Props {
	status: StatusUserResponse;
}

export default function StatusUserComponent(props: Props) {
	const classes = useStyles();

	const renderColor = () => {
		switch (props.status.id) {
			case StatusUserEnum.Active:
				return "#00cc66";
			case StatusUserEnum.Blocked:
				return "#ff0000";
			case StatusUserEnum.Suspended:
				return "#0099ff";
			default:
				return "#00cc66";
		}
	};

	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={props.status.name}
			style={{ backgroundColor: renderColor() }}
		>
			<span className={classes.spanContainer}>{props.status.name}</span>
		</div>
	);
}
